import { Link } from 'react-router-dom';
import './ProfileMenu.css';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { API_URL } from '../../utils/constants';
import { Container } from 'reactstrap';
import { tField } from '../../utils/helpers';
import { useTranslation } from 'react-i18next';

function PlansMenu() {
  const { t } = useTranslation('plans');
  const location = useLocation();
  const [plans, setPlans] = useState([]);

  const getPlanCategories = () => {
    fetch(API_URL+'/plan-categories', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {      
      if (data.success) {
        setPlans(data.categories);
      }
    })
  }

  useEffect(() => {
    getPlanCategories();
  }, []);

  return(
    <div className='profile-menu bg-light'>
      <Container>
        <div className="profile-menu-container">
          <Link
            to={'/plans'}
            className={`text-primary d-flex align-items-center${location.pathname === '/plans' ? ' active' : ''}`}
          >
            { t('all') }
          </Link>
          {plans?.map(plan => (
            <Link
              key={plan.id}
              to={'/plans/category/'+plan.id}
              className={`text-primary d-flex align-items-center${location.pathname === '/plans/category/'+plan.id ? ' active' : ''}`}
            >
              { tField(plan, 'name') }
            </Link>
          ))}
        </div>
      </Container>
    </div>
  );
}

export default PlansMenu;